import React, { useState, useEffect } from "react";
import {
  Col,
  Modal,
  Row,
  Card,
  Empty,
  Typography as typography_antd,
} from "antd";
import LeaveStatus from "../../Components/LeaveStatus";
import moment from "moment";
import LeaveStyle from "../../Components/LeavesStyle";
import "./index.css";
import {
  EyeTwoTone,
  CloseCircleOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import emailjs from "@emailjs/browser";

import Check from "../../assets/check-svgrepo-com.svg";
import axios from "axios";
import {
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  Typography,
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  Divider,
  DialogActions,
  Tooltip,
  Pagination,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import { Navigate } from "react-router-dom";

const { Title, Text } = typography_antd;
const { default: env } = require("../../config/env.js");
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export default function Leaves(props) {
  const [loading, setloading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [leavesData, setLeavesData] = useState([]);
  const [showOpen, setShowOpen] = useState(false);
  const [selectedLeaveData, setSelectedLeaveData] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(20);

  const token = useSelector((state) => state.auth.token);
  let decode = jwtDecode(token);


  const dispatch = useDispatch();
  useEffect(() => {
    if (token) {
      getLeaves();
    }
  }, [token, currentPage, limit]);

  const getLeaves = async () => {
    try {
      setloading(true);

      const getLeaves = CryptoJS.SHA256("/getLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encodeURIComponent(encrypt);
      }

      const encryptedName = encryptData("Prince");
      const encryptedStatusName = encryptData("Approved");
      const encryptedStartDate = encryptData("2015-07-01");
      const encryptedEndtDate = encryptData("2025-07-30");
      const encryptedCurrentPage = encryptData(currentPage);
      const encryptedLimit = encryptData(limit);

      const response = await fetch(`${env.backend_api_endpoint}/${getLeaves}?&page=${encryptedCurrentPage}&limit=${encryptedLimit}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData?.status === 400) {
          setloading(false);
        }
        if (errorData?.status === 404) {
          setLeavesData([]);
          setloading(false);
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        throw new Error("Error fetching attendance details");
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          setLeavesData(decryptedData?.data);
          setloading(false);
          setTotalPages(decryptedData?.totalPages);
        }
      }
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const confirmCanel = (item) => {
    setSelectedLeaveData(item);
    setShowOpen(true);
  };
  const handleCancel = () => {
    setSelectedLeaveData({});
    setShowOpen(false);
  };

  const handleConfirm = async () => {
    setShowOpen(false);

    // setLeavesData(null);

    try {

      const data = {
        leaveId: selectedLeaveData?.id,
        userId: selectedLeaveData?.applied_user_id,
        leaveStatus: "Cancel",
        actionTakenBy: selectedLeaveData?.action_taken_by,
        leaveSubType: selectedLeaveData?.leave_sub_type,
        days: selectedLeaveData?.days,
      }

      // Encrypt data
      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

      //Encrypt api endpoint
      const updateLeaves = CryptoJS.SHA256("/updateLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${updateLeaves}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      });
      
      if (!response.ok) {
        const errorData = await response.json();

        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          toast.success("Leave Canceled successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          setSelectedLeaveData({});
          getLeaves();
        }
      }
    } catch (error) {
      console.error("Error  Upadate Profile in:", error.message);
    }
  };

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{
            height: "calc(100vh - 75px)",
            // overflowY:"auto" 
            padding: "10px",
          }}
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "left",
              marginTop: "5px",
            }}
          >
            <Title
              id="page_title"
              level={2}
              style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
            >
              My Leaves
            </Title>
          </div>

          {/* View Leave Model */}
          <Dialog
            className="Leave_dialog_m"
            open={rowData.length !== 0}
            onClose={() => setRowData([])}
          >
            <DialogTitle id="dialog_title">
              Your Leave Details
              <CloseIcon
                style={{ color: "grey", cursor: "pointer" }}
                onClick={() => setRowData([])}
              />
            </DialogTitle>
            <Divider />
            <DialogContent>
              <div className="Leave_dialog">
                <Typography variant="subtitle1">Status</Typography>
                <Typography variant="body2">
                  {rowData.leave_status ? rowData.leave_status : "-"}
                </Typography>
                <Typography variant="subtitle1">Applied On</Typography>
                <Typography variant="body2">
                  {rowData.applied_date && (
                    <>
                      {moment(new Date(rowData.applied_date)).format(
                        "DD-MM-YYYY"
                      )}
                    </>
                  )}
                </Typography>
                <Typography variant="subtitle1">Date</Typography>
                <Typography variant="body2">
                  {rowData.start_date ? rowData.start_date : "-"} to{" "}
                  {rowData.end_date ? rowData.end_date : "-"}
                </Typography>
                <Typography variant="subtitle1">Leave Type</Typography>
                <Typography variant="body2">
                  {rowData.leave_title ? rowData.leave_title : "-"}
                </Typography>
                <Typography variant="subtitle1">Sub Leave Type</Typography>
                <Typography variant="body2">
                  {rowData?.sub_leave_title ? rowData?.sub_leave_title : "-"}
                </Typography>
                <Typography variant="subtitle1">Duration</Typography>
                <Typography variant="body2">
                  {rowData.days ? rowData.days : "-"}
                </Typography>
                <Typography variant="subtitle1">Duration Period</Typography>
                <Typography variant="body2">
                  {rowData.leave_duration_title
                    ? rowData.leave_duration_title
                    : "-"}
                </Typography>
                <Typography variant="subtitle1">Reason</Typography>
                <Typography variant="body2">
                  {rowData.leave_reason ? rowData.leave_reason : "-"}
                </Typography>
                <Typography variant="subtitle1">Action By</Typography>
                <Typography variant="body2">
                  {rowData.action_taken_by ? rowData.action_taken_by : "-"}
                </Typography>
              </div>
            </DialogContent>
          </Dialog>

          {/* sure want to Cancel Leave Model*/}
          <Dialog open={showOpen}>
            <DialogContent>
              <center>
                <ErrorIcon style={{ fontSize: "50px" }} />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Are you sure you want Cancel your Leave?
              </p>
            </DialogContent>
            <DialogActions
              style={{ justifyContent: "center", marginBottom: "10px" }}
            >
              <Button
                size="large"
                key="back"
                block
                onClick={handleCancel}
                style={{
                  backgroundColor: "#E20E0E",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#E20E0E",
                  textTransform: "none",
                  width: "120px",
                }}
              >
                No
              </Button>
              <Button
                block
                size="large"
                key="submit"
                type="primary"
                onClick={handleConfirm}
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  textTransform: "none",
                  color: "white",
                  width: "120px",
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* Leave Cancel successfully Model */}
          <Dialog
            open={showSuccess}
            onClose={() => setShowSuccess(false)}
            width={500}
          >
            <DialogContent>
              <center>
                <img
                  src={Check}
                  alt=""
                  style={{ height: "50px", width: "50px" }}
                />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Leave Cancel Successfully.
              </p>
              <div className="customStyle">
                <Button
                  size="large"
                  key="back"
                  onClick={() => setShowSuccess(false)}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    textTransform: "none",
                  }}
                  fullWidth
                >
                  Ok
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          {!loading ? (
            <>
              <TableContainer
                component={Paper}
                className="table-container"
                sx={{
                  maxHeight: 'calc(100vh - 200px)',
                  // maxHeight: "460px",
                  borderTopLeftRadius: 15,
                  borderTopRightRadius: 15,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0
                }}
              >
                <Table sx={{
                  minWidth: 650,
                  '& th, & td': {
                    border: '1px solid #f0f0f0',
                  },
                }}
                  aria-label="simple table"
                >
                  <TableHead
                    className="table_Header_color"
                    sx={{ height: "50px" }}
                  >
                    <TableRow style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#244DA0",
                    }}>
                      <TableCell style={{ color: "white" }}>
                        Leave Type
                      </TableCell>
                      <TableCell style={{ color: "white" }}>
                        Start Date
                      </TableCell>
                      <TableCell style={{ color: "white" }}>
                        End Date
                      </TableCell>
                      <TableCell style={{ color: "white" }}>
                        Duration
                      </TableCell>
                      <TableCell style={{ color: "white" }}>
                        Leave Status
                      </TableCell>
                      <TableCell style={{ color: "white" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leavesData?.length > 0 ? (
                      leavesData
                        .sort((a, b) => {
                          return b.date - a.date;
                        })
                        ?.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              // if(row.leave_status == "Pending"){
                              setRowData(row)
                              // }
                            }}
                          >
                            <TableCell>{row.leave_title}</TableCell>
                            <TableCell>{row.start_date}</TableCell>
                            <TableCell>{row.end_date}</TableCell>
                            <TableCell>{row.days}</TableCell>
                            <TableCell>
                              <LeaveStatus status={row.leave_status} />
                            </TableCell>
                            <TableCell>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: row.leave_status === "Pending" ? "space-evenly" : "center"
                                }}
                              >
                                {row.leave_status == "Pending" && (
                                  <Tooltip title="Cancel">
                                    <CancelIcon
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        confirmCanel(row)
                                      }}
                                      style={{
                                        color: "red",
                                        border: "none",
                                        fontSize: "19px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>
                                )}

                                <Tooltip title="View">
                                  <VisibilityIcon
                                    style={{
                                      border: "none",
                                      color: "#c8cfe3ff",
                                      fontSize: "19px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setRowData(row)}
                                  />
                                </Tooltip>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan="7">
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            No Records found
                          </span>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {leavesData?.length > 0 ?
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                    <div>
                      <Typography variant="body2" style={{ marginRight: "8px", display: "inline" }}>
                        Rows per page:
                      </Typography>
                      <select
                        value={limit}
                        onChange={(e) => {
                          setLimit(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page on limit change
                        }}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          outline: "none",
                        }}
                      >
                        {[20, 50, 100].map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    color="primary"
                    className="pagination"
                    onChange={handlePageChange}
                  />
                </div>
                : (
                  null
                )}
            </>
          ) : (
            <span class="loader"></span>
          )}
        </Card>
      </div>
    </LeaveStyle>
  );
}
